const superAdminProfileEndPoint = {
  updateProfile: (id) => ({
    url: `/update-admin-profile/${id}`,
    method: "PUT",
  }),
};

export default superAdminProfileEndPoint;
